import { render } from "./DetalharAtendimentoDetalhe.vue?vue&type=template&id=23795bc8"
import script from "./DetalharAtendimentoDetalhe.vue?vue&type=script&lang=js"
export * from "./DetalharAtendimentoDetalhe.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__